var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
        width: "600px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("ChannelWarehouseManagement.form.Basic")) + " "),
      ]),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ChannelWarehouseManagement.form.code"),
                prop: "code",
              },
            },
            [
              !_vm.isEdit
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("ChannelWarehouseManagement.form.autoCode"))
                    ),
                  ])
                : _vm._e(),
              _vm.isEdit
                ? _c("span", [_vm._v(_vm._s(_vm.form.code))])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ChannelWarehouseManagement.form.name"),
                prop: "name",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }